document.addEventListener('DOMContentLoaded', () => {
    tibletechAnimateSlider('home-feature-collection-slider');
    tibletechAnimateSlider('custom-feature-collection-slider');
    // tibletechAnimateSlider('home_pro_tab_slider');
    
    
    setSlidesToHalfWidth('brand-slider')
});

window.addEventListener('resize', () => {
    setSlidesToHalfWidth('brand-slider');
})

const tibletechAnimateSlider = sliderClassName => {
    // Find the slider object:
    const sliderToAnimate = $(`.${sliderClassName}`);
    if ( sliderToAnimate.length === 0 ) throw ('Could not find slider');

    // Find the last slide:
    const lastSlide   = sliderToAnimate.find('.grid__item').last();
    if ( lastSlide.length === 0 ) throw ('Could not find last slide');

    setInterval(() => {
        const flickityParams = lastSlide.hasClass('is-selected') ? ['select', 0] : ['next'];
        try {
            sliderToAnimate.flickity(...flickityParams);
        } catch(error) {
            console.log(`Problema con flickity con ${sliderClassName}`);
        }
    }, 3000);
}

const setSlidesToHalfWidth = sliderClassName => {
    const slider = document.querySelector(`.${sliderClassName}`);

    if ( !!slider ) {
        const sliderWidth = slider.clientWidth;
        const slideWidth = parseInt(sliderWidth / 2);
        const slides = slider.querySelectorAll('.grid__item > div');
        if ( !!slides ) {
            slides.forEach(slide => slide.style.width = `${slideWidth}px`);
        }
    }
}